import { render } from "./SheetFooter.vue?vue&type=template&id=7f48bb04&ts=true"
import script from "./SheetFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./SheetFooter.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sheet/SheetFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f48bb04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f48bb04', __exports__)) {
    api.reload('7f48bb04', __exports__)
  }
  
  module.hot.accept("./SheetFooter.vue?vue&type=template&id=7f48bb04&ts=true", () => {
    api.rerender('7f48bb04', render)
  })

}


export default __exports__